
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import KTLoader from "@/components/Loader.vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import * as Yup from "yup";
import { loaderEnabled, loaderLogo } from "@/core/helpers/config";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
    KTLoader,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const loading = ref<boolean>(false);

    const submitButton = ref<HTMLButtonElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      email: Yup.string().email().required().label("Email"),
      password: Yup.string().min(4).required().label("Password"),
    });

    const googleLogin = () => {
      location.replace(
        process.env.VUE_APP_BASE_URL + process.env.VUE_APP_GOOGLE_LOGIN_URL
      );
    };
    const linkedInLogin = () => {
      location.replace(
        process.env.VUE_APP_BASE_URL + process.env.VUE_APP_LINKEDIN_LOGIN_URL
      );
    };
    const areRolesAdded = (user) => {
      return (
        user.userRoles?.some((role) => role.name.toLowerCase() == "expert") &&
        user?.userRoles?.some(
          (role) => role.name.toLowerCase() == "investor"
        ) &&
        user?.userRoles?.some((role) => role.name.toLowerCase() == "founder")
      );
    };
    const onSubmitLogin = (values) => {
      loading.value = true;
      store.dispatch(Actions.LOGOUT);
      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }
      store
        .dispatch(Actions.SIGNIN, values)
        .then(async (res) => {
          if (res !== true) throw new Error();
          loading.value = false;
          store.commit("setAlert", {
            message: "Logged In",
            subMessage: "You have logged in successfully!",
            variant: "primary",
            duration: 4000,
            show: true,
          });
          try {
            const response = await store.dispatch(Actions.AUTH_USER);
            if (response !== true) throw new Error();
            loading.value = false;
            areRolesAdded(store.getters.getUser)
              ? router.push("/")
              : router.push("/add-role");
          } catch (err) {
            loading.value = false;
            const error = store.getters.getErrors;
            store.commit("setAlert", {
              message: "Error",
              subMessage: error,
              variant: "danger",
              duration: 4000,
              show: true,
            });
          }
        })
        .catch(() => {
          loading.value = false;
          const error = store.getters.getErrors;
          store.commit("setAlert", {
            message: "Error",
            subMessage: error,
            variant: "danger",
            duration: 4000,
            show: true,
          });
        });

      //Deactivate indicator
      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    return {
      loading,
      linkedInLogin,
      googleLogin,
      onSubmitLogin,
      login,
      submitButton,
      loaderEnabled,
      loaderLogo,
    };
  },
});
